import React, { Component } from "react";
import Pagination from "../component/Pagination";
import { DetilPxContext } from "../../context";
import { getSexString } from "../../helper/helper";
import TableServerSidePagination from "../component/ServerSideTable/TableServerSidePagination";
import moment from "moment";
import usePuskesmas from "../hooks/usePuskesmas";
import useDataRequesting from "../hooks/useDataRequesting";
import apiService from "../../apiService";
import { confirmedAlert, showLoading, toast } from "../component/Alert";
import ModalChangeRoom from "./ModalChangeRoom";
import ApiService from "../../apiService";

class TablePelayanan extends Component {
  static contextType = DetilPxContext;

  constructor(props) {
    super(props);
    this.cardNameComponentRefs = [];
    this.printListComponentRef = React.createRef();
    this.socket = this.props.socket;
    this.state = {
      headers: props.headers,
      datas: [],
      filteredDatas: [],
      isLoading: true,
      currentPage: 1,
      form: false,
      detilPx: "",
      index: "",
      modal: false,
      modalData: "",
      refDpjp: [],
      refRoom: [],
      reloadData: this.props.reloadData
    };
    this.delete = this.delete.bind(this);
    this.deletePatient = this.deletePatient.bind(this);
    this.changeData = this.changeData.bind(this);
  }

  getDataPx = async (data) => {
    showLoading("Menyiapkan Data");
    let param = {
      keyword: {
        visitId: data.id,
      },
      limit: 1,
      frDate: "",
      enDate: "",
    };

    const res = await apiService.post("registration", param);
    // console.log(res)
    if (res?.status === "success.") {
      let d = res.data.data[0]
      d.inpatient = data.inpatient
      this.context.changeDetilPx(res.data.data[0]);
      toast({ status: "success", text: "selesai menyiapkan data" });
    }
  };

  try = async (e) => {
    const data = this.state.filteredDatas.data[[e.target.value]];
    this.getDataPx(data);
    this.props.history.push(`/pelayanan-ranap/Resume`);
  };

  delete(e, data) {
    let deletePatient = this.deletePatient;
    let name = data.patients
      ? data.patients.name + " " + data.patients.last_name
      : "";
    confirmedAlert(
      "Peringatan",
      "Apakah anda akan menghapus " + name,
      function (confirmed) {
        if (confirmed) {
          deletePatient(data);
        } else {
          // NO
        }
      }
    );
  }

  deletePatient = async (data) => {
    const res = await apiService.delete("/registration/delete/" + data.id);
    let dat = this.state.filteredDatas.data.filter(
      (element) => element.id !== data.id
    );
    if (res.code === 200) {
      let res = await apiService.delete("/pcare/pendaftaran/" + data.id);
      if (data.served) {
        res = await apiService.delete("/pcare/kunjungan/" + data.id);
      }
      this.setState((prevState) => ({
        filteredDatas: {
          // object that we want to update
          ...prevState.filteredDatas, // keep all other key-value pairs
          data: dat, // update the value of specific key
        },
      }));
    }
  };

  componentDidMount() {
    this.setState({
      datas: this.props.datas,
      filteredDatas: this.props.datas,
      isLoading: false,
    });
    this.getRefDpjp()
    this.getRefRoom()
  }

  componentDidUpdate(prevProps) {
    if (this.props.datas !== prevProps.datas) {
      this.setState({
        datas: this.props.datas,
        filteredDatas: this.props.datas,
        isLoading: false,
      });
    }
  }

  getRefDpjp = async () => {
    const res = await ApiService.get("/management/users/read")
    if (res.code === 200) {
      this.setState({
        refDpjp: res.data.map(v => ({label: v.name, value: v.id}))
      })
    }
  }

  getRefRoom = async () => {
    const res = await ApiService.get("/management/room/read")
    if (res.code === 200) {
      this.setState({
        refRoom: res.data.map(v => ({label: v.name, value: v.id}))
      })
    }
  }

  getComponentRef = (i) => {
    return this.cardNameComponentRefs[i];
  };

  handlePageChange = (pageNumber) => {
    this.setState({
      currentPage: pageNumber,
    });
  };

  handleFilter = (flag) => {
    const filteredLists = [];
    if (flag !== "") {
      this.state.datas.map((data) => {
        if (data.flg_prolanis === flag) {
          filteredLists.push(data);
        }
        return "";
      });
      this.setState({
        filteredDatas: filteredLists,
        currentPage: 1,
      });
    } else {
      this.setState({
        filteredDatas: this.state.datas,
      });
    }
    return "";
  };

  changeData(datas) {
    // console.log(datas);
    this.setState({
      filteredDatas: datas,
    });
  }

  call = (currentQueueParam, clinicNameParam, clinicId) => {
    this.socket.emit("callQueue", {
      currentQueue: currentQueueParam,
      clinicName: clinicNameParam,
    });
    this.socket.emit("nextQueue", {
      type: "clinic",
      clinicId: clinicId,
      currentQueue: currentQueueParam,
    });
  };

  setNextRequest = async (queueParam) => {
    const result = await apiService.get(`/apm/queues/call/${queueParam}`);
    if (result) {
      this.socket.emit("nextQueue", {
        type: "registration",
        clinicId: result.data.registration_clinic_id,
        currentQueue: result.data.queue,
      });
    }
  };

  createBUtton(data, i) {
    if (data.inpatient.exit_date) {
      return (
        <>
          <button
            onClick={(e) => this.try(e, data)}
            className="btn btn-sm btn-success"
            value={i}
          >
            &radic;
          </button>
        </>
      );
    } else {
      return (
        <>
          <button
            onClick={(e) => this.try(e, data)}
            className="btn btn-sm btn-primary"
            value={i}
          >
            +
          </button>
        </>
      );
    }
  }

  createBUttonDelete(data, i) {
    return (
      <div>
        {
          !data.inpatient.exit_date && <button
              onClick={(e) => this.setState({ modalData: data, modal: true })}
              className="btn btn-sm btn-info"
              value={i}
          >
            <i className="fas fa-bed"/>
          </button>
        }
        <button
          onClick={(e) => this.delete(e, data)}
          className="btn btn-sm btn-danger"
          value={i}
        >
          -
        </button>
      </div>
    );
  }

  render() {
    return (
      <div>
        <TableServerSidePagination
          headers={this.state.headers}
          columnMapper={(data, i) => [
            <>
              <button
                type="button"
                disabled={
                  !moment(
                    data.queue ? data.queue.created_at : "",
                    "YYYY-MM-DD"
                  ).isSame(moment().format("YYYY-MM-DD"))
                }
                className={
                  data.queue
                    ? data.queue.status
                      ? "btn btn-warning btn-icon "
                      : "btn  btn-warning"
                    : "btn btn-warning btn-icon "
                }
                onClick={() =>
                  this.call(
                    data.queue ? data.queue.queue : "",
                    data.queue
                      ? data.queue.registration_clinic.clinic.name
                      : "",
                    data.queue ? data.queue.registration_clinic.clinic_id : ""
                  )
                }
              >
                <span className="btn-inner--icon">
                  <i className="fas fa-volume-up" style={{ fontSize: "18px" }}>
                    {" "}
                    {data.queue ? data.queue.queue : ""}
                  </i>
                </span>
              </button>

              {this.createBUtton(data, i)}
            </>,
            data.inpatient.id + ' - ' + data.inpatient.inpatient_rooms[0].room.name,
            data.inpatient.entry_date,
            data.family_folder,
            data.insurance_no,
            data.patients.nik,
            `${data.patients.name} ${data.patients.last_name}
                    (${moment().diff(
                      data.patients.birth_date,
                      "years"
                    )} tahun)`,
            data.patients.sexs.name,
            moment(data.patients.birth_date).format("DD-MM-YYYY"),
            this.createBUttonDelete(data, i),
          ]}
          data={this.state.filteredDatas}
          url={"registration/inpatient/read"}
          bodyRequest={this.props.keyword}
          callback={this.changeData}
        />
        <ModalChangeRoom
            show={this.state.modal}
            data={this.state.modalData}
            onHide={() => this.setState({ modal: false })}
            refData = {{...this.props}}
            refDpjp={this.state.refDpjp}
            refRoom={this.state.refRoom}
            reloadData={() => {
              this.setState({ modal: false })
              this.state.reloadData()
            }}
        />
      </div>
    );
  }
}

export default usePuskesmas(TablePelayanan);
